import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tips",
  "use": "icon-tips-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-tips\">\n    <path fill-rule=\"evenodd\" fill=\"#E1E5E5\" d=\"M14.999 0c8.285 0 15 6.716 15 15 0 8.284-6.715 15-15 15-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15z\" />\n    <path fill-rule=\"evenodd\" fill=\"#FFF\" d=\"M14.999 12h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1zM15.499 6a1.5 1.5 0 1 1 .001 2.999A1.5 1.5 0 0 1 15.5 6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol